import React, {useEffect} from 'react';
import { connect, useSelector } from 'react-redux'
import EIVHeader from '../EIVHeader';
import  moment  from 'moment';
import { CSS_CLASSNAME_PANEL } from '../EIVCommons';
import { Alert, Button} from 'reactstrap'
import AddTeilnehmer from './AddTeilnehmer';
import ErfassteTeilnehmer  from './TeilnehmerMelden/ErfassteTeilnehmer';
import { isShowTeilnahmedatum, isVeranstaltungsBeginnInZukunft } from './TeilnehmerMelden/teilnahmedatum';
import MeldenErstAbBeginn, { useMeldenGesperrt } from './TeilnehmerMelden/MeldenErstAbBeginn';
import Punktemeldungen from './Punktemeldungen'
import { meldeErfassteTeilnahmen, removeAllSeized } from '../store/punkteMeldung/teilnehmermeldenActionCreator';
import MeldungUnterbrochenHinweis from './TeilnehmerMelden/MeldungUnterbrochenHinweis';
import SpeichermodusHinweis from './SpeichermodusHinweis';
import { setScreen, appScreens, setScreenDruckansicht, druckVarianten } from '../store/appNavigation/actions';
import { showConfirmDialog } from '../store/confirmDialog/actions';
import { fetchPunktemeldungen } from '../store/punkteMeldung/fetchPunktemeldungen';
import { addTeilnahmeSetEFN } from '../store/punkteMeldung/actions';
import { Howl } from 'howler';
import { validateGemeldeteRefPunkte, validateRefPunkte } from './refPunkteValidator';
import BeschriftungenHinweis from './BeschriftungenHinweis';

const soundMeldungSent = new Howl({
  src: ['./sounds/dramatic-camera-zoom-6393.mp3'] // Pfad zum Sound-File
});

const AlertContentWarningRefPunkte060 = (props) => {
	return (
		<p className='small'>
			Die Fortbildungsordnung der zuständigen Landesärztekammer regelt die Vergabe der Referentenpunkte. <br/>
			<b>Sie</b> sind für die Einhaltung dieser Regel <b>verantwortlich</b>. 
			Grundsätzlich ist die Vergabe der Ref.-Punkte in Hessen für die Veranstaltungen der Kategorien <b>(A)</b> und <b>(H)</b> vorgesehen. Darüber hinaus kann der WL/Moderator bei jeder Kategorie 1 Ref. Punkt erhalten, sofern dies von der zuständigen Landesärztekammer entsprechend geregelt ist.
		</p>
	)
}
const HinweisRefPunkte080 = (props) => {
	return (
		<p className='small mb-0'>
			Für die Referierendentätigkeit, Qualitätszirkelmoderation und die Tätigkeit als
			Wissenschaftliche Leitung kann 1 Punkt pro Beitrag – unbenommen der Punkte für die
			persönliche Teilnahme – gemeldet werden. Bitte geben Sie in dem Feld die entsprechende
			Gesamt-Punktzahl an. Beachten Sie hierbei, dass pro Beitrag / Vortrag ein Punkt
			berechnet wird. Für die Tätigkeit als Wissenschaftliche Leitung wird ein Punkt pro
			Fortbildungsmaßnahme vergeben, wenn die wissenschaftliche Leitung bei der Fortbildung
			durchgehend anwesend war.
		</p>
	)
}
/**
 * Kammertexte zu den Ref/Mod/WL-Punkten, Schlüssel sind die ersten 6 Stellen der VNR
 * (ISO-3166-Land + KID) - dieselbe Systematik wie bei den Validatoren in refPunkteValidator.js.
 *
 * `warnung` erscheint nur, wenn die Kammer eine Validierung hat und diese anschlägt.
 * `hinweis` wird dauerhaft angezeigt, unabhängig von den vergebenen Punkten.
 * Kammern ohne Eintrag zeigen nichts an.
 */
const kammerTexteRefPunkte = {
	'276060': { warnung: AlertContentWarningRefPunkte060 },
	'276080': { hinweis: HinweisRefPunkte080 }
};

const getKammerTexteRefPunkte = (vnr) => kammerTexteRefPunkte[vnr.substring(0, 6)] || {};

const AlertContentWarningRefPunkte = (props) => {
	const { vnr } = props;
	const Warnung = getKammerTexteRefPunkte(vnr).warnung;
	return Warnung ? <Warnung /> : null;
}

const HinweisRefPunkte = (props) => {
	const { vnr } = props;
	const Hinweis = getKammerTexteRefPunkte(vnr).hinweis;
	if(!Hinweis) return null;
	return(
		<Alert color="info">
			<h6 className="alert-heading">Hinweis zur Vergabe der Ref/Mod/WL-Pkte.</h6>
			<Hinweis />
		</Alert>
	);
}

const VeranstaltungPage = (props) => {
	const { vnr, countErfassteTeilnehmer,
		refreshPunktemeldungen, showConfirmDialog, veranstaltung, meldeErfassteTeilnahmen, meldungLaeuft,
		removeAllSeized, erfassteEFNs, addTeilnahmeState, setScreen, zeigeDruckansicht,
		countPunktemeldungen } = props;
	useEffect(() => {
		if( veranstaltung !== undefined ){
			
			refreshPunktemeldungen(vnr, veranstaltung.bearer)
		}	
	}, [vnr, veranstaltung, refreshPunktemeldungen]);
  const erfassteTeilnahmen = useSelector( state => state.punkteMeldung.erfassteTeilnahmen[vnr]);
  const teilnahmeMeldungen = useSelector( state => state.punkteMeldung.teilnahmeMeldungen[vnr]);
	// Vor dem fruehen return: eine Hook-Reihenfolge, die zwischen Rendern wechselt, bricht React ab.
	// Und genau einmal - der Wert geht an den Hinweis und an *beide* Meldeknoepfe, zwei Aufrufe
	// waeren zwei Timer.
	const meldenGesperrt = useMeldenGesperrt(veranstaltung);
	if( veranstaltung === undefined) return ( <UnbekannteVNR /> );
	const showTeilnahmedatum = isShowTeilnahmedatum(veranstaltung)
	const veranstaltungLiegtInZukunft = isVeranstaltungsBeginnInZukunft(veranstaltung)
	const showWarningRefPunkte = !validateRefPunkte(vnr, veranstaltung, erfassteTeilnahmen, teilnahmeMeldungen);
	const showWarningGemeldeteRefPunkte = !validateGemeldeteRefPunkte(vnr, veranstaltung, teilnahmeMeldungen);
	const highLightRefpunkte = showWarningGemeldeteRefPunkte || showWarningRefPunkte;
	return(
		<>
		<EIVHeader></EIVHeader>
		<div className="container bg-body-tertiary pt-2 pb-2">
			<div className="h3">Punktemeldung</div>
			<VeranstaltungsItem
				setScreen={setScreen}
				veranstaltung={veranstaltung} className={CSS_CLASSNAME_PANEL+ " container"}></VeranstaltungsItem>
			{/* Vor der Verzweigung: die Zeile gilt auch fuer "liegt in der Zukunft" und
			    "gesperrt fuer Veranstalter", die den Rest der Seite ersetzen. */}
			<SpeichermodusHinweis vnr={vnr} />
			{ veranstaltungLiegtInZukunft?
			<VeranstaltungLiegtInZukunft veranstaltung={veranstaltung} />:
			<div>
				{ veranstaltung.gesperrt_fuer_veranstalter?
						<GesperrtFuerVeranstalter />:
					<>
					<div className="h4">Teilnahmen erfassen</div>
					<HinweisRefPunkte vnr={vnr} />
					<AddTeilnehmer veranstaltung = {veranstaltung} addTeilnahmeState = {addTeilnahmeState} >
					
					</AddTeilnehmer>
					{ showWarningRefPunkte &&
						<Alert color="warning">
							<h5 className="alert-heading">Warnung: Auffällig viele Ref/Mod/WL-Pkte.!</h5>
							<AlertContentWarningRefPunkte vnr={vnr} />
						</Alert>	
					}	
					<div className="h4">{countErfassteTeilnehmer > 0
						?`${countErfassteTeilnehmer} ${countErfassteTeilnehmer === 1?"Teilnahme":"Teilnahmen"} erfasst, noch nicht gemeldet`
						:"Erfasste Teilnahmen"}</div>
					{/* Ohne erfasste Teilnahmen bleibt der Knopf stehen: dann entsteht genau das
					    leere Formular zum Mitnehmen - der Moment, in dem man es am dringendsten
					    braucht. Die Beschriftung sagt das, damit niemand raten muss. */}
					<div className="mb-2">
						<Button size="sm" outline color="secondary"
							title="Anwesenheitsliste zum Unterschreiben, mit Nachtragszeilen für Teilnehmende ohne erfasste EFN"
							onClick={ (e) => zeigeDruckansicht(druckVarianten.anwesenheitsliste) }>
							{countErfassteTeilnehmer > 0?"Teilnehmerliste drucken":"Leere Teilnehmerliste drucken"}
						</Button>
					</div>
					<BeschriftungenHinweis vnr={vnr} />
					<div className={CSS_CLASSNAME_PANEL}>
						<MeldungUnterbrochenHinweis vnr={vnr} />
						<MeldenErstAbBeginn veranstaltung={veranstaltung} />
						{countErfassteTeilnehmer > 24 && 
							<div className='d-flex justify-content-between'>
								<Button onClick={ (e) => {
									showConfirmDialog(
										"Teilnahmen verbindlich melden", 
										"Die erfolgte Meldung kann nicht rückgängig gemacht werden. Sie sind für die Richtigkeit, Vollständigkeit und Rechtzeitigkeit der Meldung verantwortlich. Sollen die erfassten Daten gemeldet werden?",
										(e) => { 
											meldeErfassteTeilnahmen(vnr);
											soundMeldungSent.play();
										},
										`${countErfassteTeilnehmer} ${countErfassteTeilnehmer === 1?"Teilnahme":"Teilnahmen"} melden` )
									}}   color="info" disabled={meldungLaeuft || meldenGesperrt}>{meldungLaeuft ? "wird gemeldet …"
										: `${countErfassteTeilnehmer} ${countErfassteTeilnehmer === 1 ? "Teilnahme" : "Teilnahmen"} verbindlich melden`}</Button>
									<Button title='Alle erfassten entfernen' outline color="danger" disabled={meldungLaeuft} onClick = { (e) => removeAllSeized(vnr, erfassteEFNs) }>
										Alle ({countErfassteTeilnehmer}) entfernen 
									</Button>
							</div>

						}	
						<ErfassteTeilnehmer showTeilnahmedatum={showTeilnahmedatum} vnr={vnr} highLightRefpunkte = {highLightRefpunkte} className={CSS_CLASSNAME_PANEL}></ErfassteTeilnehmer>
						{countErfassteTeilnehmer > 0 && 
							<div className='d-flex justify-content-between'>
								<Button onClick={ (e) => {
									showConfirmDialog(
										"Teilnahmen verbindlich melden", 
										"Die erfolgte Meldung kann nicht rückgängig gemacht werden. Sie sind für die Richtigkeit, Vollständigkeit und Rechtzeitigkeit der Meldung verantwortlich. Sollen die erfassten Daten gemeldet werden?",
										(e) => { 
											meldeErfassteTeilnahmen(vnr);
											soundMeldungSent.play();
										},
										`${countErfassteTeilnehmer} ${countErfassteTeilnehmer === 1?"Teilnahme":"Teilnahmen"} melden` )
									}}   color="info" disabled={meldungLaeuft || meldenGesperrt}>{meldungLaeuft ? "wird gemeldet …"
										: `${countErfassteTeilnehmer} ${countErfassteTeilnehmer === 1 ? "Teilnahme" : "Teilnahmen"} verbindlich melden`}</Button>
								{countErfassteTeilnehmer > 9 &&
									<Button title='Alle erfassten entfernen' outline color="danger" disabled={meldungLaeuft} onClick = { (e) => removeAllSeized(vnr, erfassteEFNs) }>
										Alle ({countErfassteTeilnehmer}) entfernen 
									</Button>
								}

							</div>
						}
					</div>
					</>
				}
				{ showWarningGemeldeteRefPunkte && !showWarningRefPunkte &&
						<Alert color="warning">
							<h5 className="alert-heading">Warnung: Auffällig viele Ref/Mod/WL-Pkte. gemeldet!</h5>
							<AlertContentWarningRefPunkte vnr={vnr} />
						</Alert>	
					}	
				<div className="h4">Protokoll – bereits gemeldet</div>
				{/* Anders als bei der Teilnehmerliste: ein Protokoll ohne Meldungen waere ein
				    leeres Blatt mit Kopf und Fussnote, sonst nichts. */}
				{ countPunktemeldungen > 0 &&
					<div className="mb-2">
						<Button size="sm" outline color="secondary"
							title="Meldeprotokoll zur Ablage beim Veranstalter"
							onClick={ (e) => zeigeDruckansicht(druckVarianten.meldeprotokoll) }>
							Protokoll drucken / als CSV speichern
						</Button>
					</div>
				}
				<div className={CSS_CLASSNAME_PANEL}>
					<Punktemeldungen vnr={vnr} highLightRefpunkte = {highLightRefpunkte}></Punktemeldungen>
				</div>
			</div>
			}
		</div>
		</>
	)
}

const getErfasstenEFNs = stateTeilnahmen => {
	if(!stateTeilnahmen) return null;
	const teilnahmen = Object.values(stateTeilnahmen)
	const efns = teilnahmen.map( e => e.efn );
	const joinedEFNs = efns.join(" ");
	return joinedEFNs;
}
const mapStateToProps = (state) => {
	return {
		vnr : state.appNavigation.selectedVNR,
		veranstaltung : state.veranstaltungen[state.appNavigation.selectedVNR],
		countErfassteTeilnehmer : state.punkteMeldung.erfassteTeilnahmen[state.appNavigation.selectedVNR] 
					=== undefined?0:Object.keys(state.punkteMeldung.erfassteTeilnahmen[state.appNavigation.selectedVNR]).length,
		addTeilnahmeState : state.punkteMeldung.addTeilnahme[state.appNavigation.selectedVNR],
		countPunktemeldungen : state.punkteMeldung.teilnahmeMeldungen[state.appNavigation.selectedVNR]
					=== undefined?0:Object.keys(state.punkteMeldung.teilnahmeMeldungen[state.appNavigation.selectedVNR]).length,
		erfassteEFNs: getErfasstenEFNs(state.punkteMeldung.erfassteTeilnahmen[state.appNavigation.selectedVNR]),
		// Waehrend der Uebertragung sind Melden und "Alle entfernen" gesperrt: der zweite Druck
		// schickte jede Teilnahme ein zweites Mal ueber die Leitung, und Entfernen mitten in der
		// Schleife nimmt Zeilen weg, die gerade unterwegs sind.
		meldungLaeuft: Boolean((state.punkteMeldung.meldeversuch[state.appNavigation.selectedVNR] || {}).laeuft)

	}
}
const mapDispatchToProps = dispatch => ({
		showConfirmDialog: (title, message, onConfirm, confirmLabel) => dispatch(showConfirmDialog(title, message, onConfirm, confirmLabel)),
		meldeErfassteTeilnahmen: (vnr) => dispatch(meldeErfassteTeilnahmen(vnr)),
		removeAllSeized: (vnr, erfassteEFNs) => dispatch(removeAllSeized(vnr, erfassteEFNs)),
		changeEFN: (vnr, efn) => dispatch(addTeilnahmeSetEFN(vnr, efn)),
		refreshPunktemeldungen: (vnr, bearer) => dispatch(fetchPunktemeldungen(vnr, bearer)),
		setScreen : (screen) => dispatch(setScreen(screen)),
		zeigeDruckansicht : (variante) => dispatch(setScreenDruckansicht(variante))
})
export default connect(mapStateToProps, mapDispatchToProps)(VeranstaltungPage) 

function VeranstaltungLiegtInZukunft(props){
	const {veranstaltung} = props
	const beginnDatum = moment(veranstaltung.beginn).format('DD.MM.YYYY')
	return(
		<div className="jumbotron" role="alert">
			<h4 className="display-6">Die Veranstaltung beginnt in der Zukunft!</h4>
			<p className="lead">Die Teilnahmen können erst ab dem {beginnDatum} erfasst werden.</p>
		</div>
	)
}
function GesperrtFuerVeranstalter(props){
	return(
		<div className="jumbotron" role="alert">
			<h4 className="display-6">Die Veranstaltung ist geschlossen.</h4>
			<p className="lead">
				Die Teilnahmen können entweder vorübergehend oder gar nicht mehr gemeldet werden. Bei Fragen oder Unstimmigkeiten kontaktieren Sie bitte die zuständige Anerkennungsstelle.
			</p>
		</div>
	)
}

function UnbekannteVNR(props){
	return(
		<Alert color="info">
		<h4 className="alert-heading">Unbekannte VNR!</h4>
		 <p>
			 Für die angegebene VNR liegen keine Veranstaltungsdaten vor. Bitte laden Sie vorerst die Veranstaltung.
		 </p>
		 <div>
			 <Button href="/veranstaltungen" outline color="secondary">Veranstaltungen bitte hier laden</Button>
		 </div>
	 </Alert>
	)
}

function VeranstaltungsItem(props){
	const {veranstaltung} = props;
	const endeZeit = moment(veranstaltung.beginn).format('DD.MM.YYYY') !== moment(veranstaltung.ende).format('DD.MM.YYYY')?
		moment(veranstaltung.ende).format('DD.MM.YYYY HH:mm'):moment(veranstaltung.ende).format('HH:mm')
	return (<div className={`clickableValue container-fluid ${CSS_CLASSNAME_PANEL}`}>
			<div>{veranstaltung.vnr}</div>
			<div className="h5">{veranstaltung.thema}</div>
			<div>{veranstaltung.unterthema}</div>
			<div className="row text-muted ">
				<div className="col-12 col-sm-7 col-md-6 col-lg-8">Kat. ({veranstaltung.kategorie}) {moment(veranstaltung.beginn).format('DD.MM.YYYY HH:mm')} - {endeZeit}</div>
				<div className="col-12 col-sm-5 col-md-6 col-lg-4 text-end ">
					<Button  onClick={(e) =>  {e.preventDefault(); e.stopPropagation(); props.setScreen(appScreens.veranstalterPage)}} size="sm" 
					outline color="info">zurück zur Veranstaltungsliste</Button>
				</div>
			</div>
	</div>);

}
